import { post } from '../axios'

const baseURL = process.env.VUE_APP_SETTING

// 添加配置
export function add_pdp_ambience_config(map, option) {
  return post(`${baseURL}/pdpAmbienceConfig/add`, map, option)
}
// 编辑配置
export function edit_pdp_ambience(map, option) {
  return post(`${baseURL}/pdpAmbienceConfig/edit`, map, option)
}
// 编辑配置
export function get_pdp_ambience_list(map, option) {
  return post(`${baseURL}/pdpAmbienceConfig/list`, map, option)
}
